<mat-form-field>
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select [formControl]="formControl">
    @if (clearable) {
      <mat-option [value]="null" selected>{{
        'common.NO_SELECTION' | transloco
      }}</mat-option>
    }
    @for (item of marketAreas$ | async; track item.id) {
      <mat-option [value]="item.id" [disabled]="item.disabled">
        {{ item.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
